import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { CatalogProvider } from "./context/CatalogContext";
import { StationsList } from "./pages/StationsList";
import { StationDetailPage } from "./pages/StationDetail";
import { TrainsList } from "./pages/TrainsList";
import { LiveBoard } from "./pages/LiveBoard";
import { TrainSchedule } from "./pages/TrainSchedule";
import { FindTrains } from "./pages/FindTrains";
import { LiveMap } from "./pages/LiveMap";
import { TrackTrain } from "./pages/TrackTrain";

export function App() {
  return (
    <CatalogProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/stations" replace />} />
          <Route path="/stations" element={<StationsList />} />
          <Route path="/stations/:id" element={<StationDetailPage />} />
          <Route path="/trains" element={<TrainsList />} />
          <Route path="/trains/live" element={<LiveBoard />} />
          <Route path="/trains/:id" element={<TrainSchedule />} />
          <Route path="/routes" element={<FindTrains />} />
          <Route path="/map" element={<LiveMap />} />
          <Route path="/map/:id" element={<TrackTrain />} />
          <Route path="/track" element={<TrackTrain />} />
          <Route path="*" element={<Navigate to="/stations" replace />} />
        </Route>
      </Routes>
    </CatalogProvider>
  );
}

export default App;
